import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Card, CardBody, Row, Col, Spinner, Label } from "reactstrap"
import { AvForm, AvField, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import FileUpload from "components/Common/file-upload/file-upload.component"
import { adminPrefix } from "configs/routePrefix"
import { toast } from "react-toastify"
import CancelModal from "components/CancelModal"
import LeadService from "services/Admin/LeadService"
import SelectOptions from "components/SelectOptions"
import AppoinmentService from "services/Admin/AppoinmentService"
import Select from "react-select";
import { SuccessOk, SuccessCreated } from "configs/statusCode"
import CompoundService from "services/Admin/CompoundService"
import BuildingService from "services/Admin/BuildingService"
import PropertyService from "services/Admin/PropertyService"
import SalesRepsService from "services/Admin/SalesRepsService"
import SuccessModal from "components/SucessModal"
import moment from "moment"
import SelectComponent from "pages/Provider/Deals/Select";
import { unitTypeOptions } from "Enums/fixedData";
import ResaleService from "services/Admin/ResaleService";
import UnitTypesService from "services/Admin/UnitTypesService";

const initialState = {
    title: "",
    description: "",
    date: "",
    time: "",
    status: "upcoming",
    selectedLead: null,
    activityType: null,
    selectedBulding: null,
    selectedCompound: null,
    selectedProperty: null,
    selectedResale: null,
    location: "",
    sales_rep_id: null,

}

const AddAppointment = (props) => {
    const [successModal, setSuccessModal] = useState(false)
    const id = props.match.params.id
    const leadId = props.match.params.leadId
    const owner = props.match.params.owner
    const [formState, setFormState] = useState(initialState)
    const [modal, setModal] = useState(false)
    const [leadsOptions, setLeadOptions] = useState([])
    const [CompoundOptions, setCompoundptions] = useState([])
    const [buildingOptions, setBuildingOptions] = useState([])
    const [propertyOptions, setPropertyOptions] = useState([])
    const [salesRepOptions, setSalesRepOptions] = useState([])
    const [resaleOption, setResaleOption] = useState([])
    const leadService = new LeadService()
    const appoinmentService = new AppoinmentService()
    const buildingService = new BuildingService()
    const propertyService = new PropertyService()
    const salesRepsService = new SalesRepsService()
    const compoundService = new CompoundService()
    const resaleService = new ResaleService()
    const [unitType, setUnitType] = useState('')
    
    const [loading, setLoading] = useState(false)

    const currentday = new Date().getFullYear() + '-' + ((new Date().getMonth() + 1) < 10 ? `0${(new Date().getMonth() + 1)}` : (new Date().getMonth() + 1)) + '-' + new Date().getDate()

    useEffect(() => {
        const id = formState ?.selectedCompound ?.value
            if (id && formState?.unitType?.label === "Property in Compound") {
            buildingService.getDropDown(id).then(res => {
                const newOptions = res.data.map(item => {
                    return {
                        label: item.name.en,
                        value: item.id
                    }
                })
                setBuildingOptions(newOptions)
            })
        }
    }, [formState.selectedCompound])

    // useEffect(() => {
    //     resaleService.getList().then(res => {
    //         const newOptions = res.data.data.map(item => {
    //             return {
    //                  label: item.name.en ?item.name.en :item.name,
    //                  value: item.id
    //              }
    //         })
    //         setResaleOption(newOptions)
    //     })
    // }, [])

    useEffect(() => {
        const id = formState ?.selectedBulding ?.value
        if (id) {
            propertyService.getDropDown(id).then(res => {
                const newOptions = res.data.map(item => {
                    return {
                        label: item.name.en,
                        value: item.id
                    }
                })
                setPropertyOptions(newOptions)
            })
        }
    }, [formState.selectedBulding])

    useEffect(() => {
        const id = formState ?.selectedCompound ?.value
        if(id && formState?.unitType?.label === "Property in Compound"){
            propertyService.getDropDownCustom(id).then(res => {
                const newOptions = res.data?.map(item => {
                    return {
                        label: item.name.en,
                        value: item.id
                    }
                })
                setPropertyOptions(newOptions)
            })
        } else if(id && formState?.unitType?.label === "Resale in Compound"){
            resaleService.getResaleInCompoundDropDown(id).then(res => {
                const newOptions = res.data?.map(item => {
                    return {
                        label: item.name.en,
                        value: item.id
                    }
                })
                setResaleOption(newOptions)
            })
        }
    }, [formState.selectedCompound])

    useEffect(() => {
        if(formState?.unitType?.label === "Resale Unit Outside Compound"){
            resaleService.getIndependentResaleDropDown().then(res => {
                const newOptions = res.data.map(item => {
                    return {
                         label: item.name.en ?item.name.en :item.name,
                         value: item.id
                     }
                })
                setResaleOption(newOptions)
            })
        }
        if(formState?.unitType?.label === "Resale in Compound"){
            compoundService.getCompoundWithResaleDropDown().then(res => {
                const newOptions = res.data.map(item => {
                    return {
                         label: item.name.en ?item.name.en :item.name,
                         value: item.id
                     }
                })
                setCompoundptions(newOptions)
            })
        }
        if(formState?.unitType?.label ==="Property in Compound"){
            setCompoundptions([])
        }
    }, [formState.unitType])
    
    useEffect(() => {
         if (id !== "add" && !!id) {
            appoinmentService.find(id).then(response => {
                if (response.status === SuccessOk) {
                    const data = response.data
                    
                    if(!!data?.other){
                        setFormState({
                            unitType: {label: 'Other'},
                            resale_name: data?.other,
                            title: data.title,
                            description: data.description,
                            selectedLead: {
                                label: `${data?.lead_id} / ${data.client?.name}`,
                                value: data?.lead_id
                            },
                            sales_rep_id: {
                                label: `${data.sales_rep?.id} / ${data.sales_rep?.name}`,
                                value: data.sales_rep?.id
                            },
                            activityType: {
                                label: data.type,
                                value: data.type
                            },
                            time: moment(data.time, ["h:mm A"]).format("HH:mm"),
                            date: data.date,
                            status: data.status[0].toLowerCase() + data.status.substring(1),
                            location: data?.type === "visit" ? data.location : ""
                        })
                        setUnitType({label: 'Other'})
                    } else if(!!data?.unit?.building?.id || ((!!data?.unit?.compound?.name?.en && !!data?.unit?.name?.en))){
                        setFormState({
                            unitType: {label: 'Property in Compound'},
                            selectedBulding: data.unit?.building?.id ? {
                                label: data.unit?.building?.name?.en,
                                value: data.unit?.building?.id,
                            } : null,
                            selectedCompound: {
                                label: data?.unit?.compound?.name?.en,
                                value: data?.unit?.compound?.id,
                            },
                            selectedProperty: {
                                label: data.unit?.name?.en,
                                value: data.unit?.id,
                            },
                            title: data.title,
                            description: data.description,
                            date: data.date,
                            time: moment(data.time, ["h:mm A"]).format("HH:mm"),
                            status: data.status[0].toLowerCase() + data.status.substring(1),
                            selectedLead: {
                                label: `${data?.lead_id} / ${data.client?.name}`,
                                value: data?.lead_id
                            },
                            activityType: {
                                label: data.type,
                                value: data.type
                            },
                            // selectedProperty: data?.unit_id,
                            // selectedBulding: data.building_id,
                            // selectedCompound: data.compound_id,
                            sales_rep_id: {
                                label: `${data.sales_rep?.id} / ${data.sales_rep?.name}`,
                                value: data.sales_rep?.id
                            },
                            location: data?.type === "visit" ? data.location : ""
                        })
                        setUnitType({label: 'Property in Compound'})
                    } else if(!data?.unit && !!data.resale.compound.name.en && !!data?.resale?.name?.en){
                        setFormState({
                            unitType: {label: 'Resale in Compound'},
                            selectedCompound: {
                                label: data.resale.compound.name.en,
                                value: data.resale.compound.id,
                            },
                            selectedResale: {
                                label: data.resale.name.en,
                                value: data.resale.id,
                            },
                            title: data.title,
                            description: data.description,
                            date: data.date,
                            time: moment(data.time, ["h:mm A"]).format("HH:mm"),
                            status: data.status[0].toLowerCase() + data.status.substring(1),
                            selectedLead: {
                                label: `${data?.lead_id} / ${data.client?.name}`,
                                value: data?.lead_id
                            },
                            activityType: {
                                label: data.type,
                                value: data.type
                            },
                            // selectedProperty: data?.unit_id,
                            // selectedBulding: data.building_id,
                            // selectedCompound: data.compound_id,
                            sales_rep_id: {
                                label: `${data.sales_rep?.id} / ${data.sales_rep?.name}`,
                                value: data.sales_rep?.id
                            },
                            location: data?.type === "visit" ? data.location : ""
                        })
                        setUnitType({label: 'Resale in Compound'})
                    } else {
                        setFormState({
                            unitType: {label: 'Resale Unit Outside Compound'},
                            selectedResale: {
                                label: data.resale.name.en,
                                value: data.resale.id,
                            },
                            title: data.title,
                            description: data.description,
                            date: data.date,
                            time: moment(data.time, ["h:mm A"]).format("HH:mm"),
                            status: data.status[0].toLowerCase() + data.status.substring(1),
                            selectedLead: {
                                label: `${data?.lead_id} / ${data.client?.name}`,
                                value: data?.lead_id
                            },
                            activityType: {
                                label: data.type,
                                value: data.type
                            },
                            // selectedProperty: data?.unit_id,
                            // selectedBulding: data.building_id,
                            // selectedCompound: data.compound_id,
                            sales_rep_id: {
                                label: `${data.sales_rep?.id} / ${data.sales_rep?.name}`,
                                value: data.sales_rep?.id
                            },
                            location: data?.type === "visit" ? data.location : ""
                        })
                        setUnitType({label: 'Resale Unit Outside Compound'})
                    }
                    // setFormState({
                    //     ...formState,
                    //     title: data.title,
                    //     description: data.description,
                    //     date: data.date,
                    //     time: moment(data.time, ["h:mm A"]).format("HH:mm"),
                    //     status: data.status[0].toLowerCase() + data.status.substring(1),
                    //     selectedLead: {
                    //         label: `${data?.lead_id} / ${data.lead?.name}`,
                    //         value: data?.lead_id
                    //     },
                    //     activityType: {
                    //         label: data.type,
                    //         value: data.type
                    //     },
                    //     // selectedProperty: data?.unit_id,
                    //     // selectedBulding: data.building_id,
                    //     // selectedCompound: data.compound_id,
                    //     sales_rep_id: {
                    //         label: `${data.owner?.id} / ${data.owner?.name}`,
                    //         value: data.owner?.id
                    //     },
                    //     location: data?.type === "visit" ? data.location : ""
                    // })
                }
            })
        }

    }, [])

    useEffect(() => {
        if (leadsOptions.length) {
            const lead = leadsOptions.find(item => parseInt(item.value) === parseInt(leadId))
            if (lead) {
                setFormState({ ...formState, selectedLead: lead })
            }
        }
    }, [leadsOptions])

    const handleValidSubmit = (e, v) => {
        if (!formState.selectedLead) {
            toast.error("Select Client Name")
            return
        } 
        else if (!formState.sales_rep_id) {
            toast.error("Select Sales Rep")
            return
        }
        else if (!formState.activityType) {
            toast.error("Select Activity Type")
            return
        }
        else if (!formState.unitType) {
            toast.error("Select Unit Type")
            return
        }
        else if ((formState.unitType.label === "Property in Compound" || formState.unitType.label === "Resale in Compound")&& !formState.selectedCompound) {
            toast.error("Select Compound")
            return
        }
        else if (formState.unitType.label=== "Property in Compound" && !formState.selectedProperty) {
            toast.error("Select Property")
            return
        }
        else if ((formState.unitType.label === "Resale in Compound" || formState.unitType.label === "Resale Unit Outside Compound") && !formState.selectedResale) {
            toast.error("Select Resale")
            return
        }
        else if ((formState?.unitType?.label === "other" && !formState.resale_name)) {
            toast.error("Please Enter Resale Name")
            return
        }
        else {
            setLoading(true)
            if (formState.activityType.value === "visit") {
                if (!validate(formState.location)) {
                    toast.error("Location format invalid")
                    setLoading(false)
                    return
                } else {
                    data["location"] = formState.location
                }
            }
            if (id !== "add" && !!id) {
                let info ={}
                if(formState.unitType.label=== "Property in Compound"){
                    info ={
                        compound_id: formState?.selectedCompound?.value,
                        building_id: formState?.selectedBulding?.value,
                        unit_id: formState.selectedProperty.value,
                        resale_id: null,
                        other: null
                    }
                } else if( formState.unitType.label === "Resale in Compound"){
                    info = {
                        compound_id: formState?.selectedCompound?.value,
                        resale_id: formState?.selectedResale?.value,
                        unit_id: null,
                        other: null
                    }
                } else if(formState?.unitType?.label === "Resale Unit Outside Compound"){
                    info = {
                        resale_id: formState.selectedResale.value,
                        unit_id: null,
                        other: null
                    }
                } else{
                    info = {
                        other: formState.resale_name,
                        resale_id: null,
                        unit_id: null
                    }
                }
                const data = {
                    ...info,
                    title: formState.title,
                    description: formState.description,
                    date: formState.date,
                    time: formState.time,
                    status: formState.status,
                    type: formState.activityType.value,
                    lead_id: formState.selectedLead.value,
                    sales_rep_id: formState.sales_rep_id.value,
                    location: formState?.location ? formState.location : null
                }
                appoinmentService.update(id, data).then(response => {

                    if ( response && response.status === SuccessOk) {
                        setLoading(false)
                        setSuccessModal(true)
                        // toast.success("Appointment updated Successfully")
                        // props.history.goBack()
                    } else {
                        setLoading(false)
                    }
                })
            } else {
                let info ={}
                if(formState.unitType.label=== "Property in Compound"){
                    info ={
                        compound_id: formState?.selectedCompound?.value,
                        building_id: formState?.selectedBulding?.value,
                        unit_id: formState.selectedProperty.value,
                    }
                } else if( formState.unitType.label === "Resale in Compound"){
                    info = {
                        compound_id: formState?.selectedCompound?.value,
                        resale_id: formState?.selectedResale?.value,
                    }
                }else if (formState?.unitType?.label === "Resale Unit Outside Compound"){
                    info = {
                        resale_id: formState.selectedResale.value,
                    }
                } else{
                    info= {
                        other: formState.resale_name
                    }
                }
                const data = {
                    ...info,
                    title: formState.title,
                    description: formState.description,
                    date: formState.date,
                    time: formState.time,
                    status: formState.status,
                    type: formState.activityType.value,
                    lead_id: formState.selectedLead.value,
                    sales_rep_id: formState.sales_rep_id.value,
                    location: formState?.location ? formState.location : null
                }
               appoinmentService.create(data).then(response => {
                    if (response && response.status === SuccessCreated) {
                        setLoading(false)
                        setSuccessModal(true)
                    } else {
                        setLoading(false)
                    }
                })
            }
        }
    }

    const handleFieldChange = (e) => {
        setFormState({ ...formState, [e.target.name]: e.target.value })
    }
    useEffect(() => {
        leadService.getDropDown().then(res => {
            const newOptions = res.data.map(item => {
                return {
                    label: `${item.id} / ${item.name}`,
                    value: item.id
                }
            })
            setLeadOptions(newOptions)
        })
    }, [formState.selectedBulding])


    useEffect(() => {
        salesRepsService.getDropDown().then(res => {
            const newOptions = res.data.map(item => {
                return {
                    label: item.name.en ? item.name.en : item.name,
                    value: item.id
                }
            })
            if (owner) {
                let selectedOwner = newOptions.find(option => parseInt(option.value) === parseInt(owner))
                setFormState((formState) => ({ ...formState, sales_rep_id: selectedOwner }))
            }
            setSalesRepOptions(newOptions)
        })
    }, [owner])
    return (
        <React.Fragment>
            <div className='page-content'>
                <MetaTags>
                    <title>Book Appoinment</title>
                </MetaTags>
                <Container fluid>
                    <h4>
                        {/* <button className="p-0 m-0 border-0 bg-light"
                            onClick={() => {
                                setModal(true)
                            }}>
                            <i className="fa fa-arrow-left text-primary me-2"></i>
                        </button>
                         */}
                        Book Appointment
          </h4>
                    <AvForm
                        className='form-horizontal'
                        onValidSubmit={(e, v) => {
                            handleValidSubmit(e, v)
                        }}>
                        <Card className="w-100 mt-4">
                            <CardBody>
                                <Row className="mb-4">
                                    <Col md={6}>
                                        <div className='mb-3'>
                                            <AvField
                                                name='title'
                                                label="Appointment Title"
                                                className='form-control'
                                                placeholder='Type Appointment Title'
                                                required
                                                errorMessage="This field is required"
                                                onChange={(e) => handleFieldChange(e)}
                                                bsSize="lg"
                                                value={formState.title}
                                            />
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <label>Client Name</label>
                                        <Select
                                            placeholder='Select'
                                            options={leadsOptions}
                                            className='mb-3 '
                                            onChange={data => setFormState({ ...formState, selectedLead: data })}
                                            value={formState.selectedLead}
                                            setOptions={options => setLeadOptions(options)}
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <label>Sales Rep</label>
                                        <Select
                                            placeholder='Select'
                                            options={salesRepOptions}
                                            className='mb-3'
                                            onChange={(data) => {
                                                setFormState({ ...formState, sales_rep_id: data });
                                            }}
                                            value={formState.sales_rep_id}

                                        />
                                    </Col>
                                    <Col md={6}>
                                        <div className='mb-3'>
                                            <AvField
                                                name='date'
                                                label="Date"
                                                className='form-control'
                                                required
                                                errorMessage="This field is required"
                                                type='date'
                                                onChange={(e) => handleFieldChange(e)}
                                                bsSize="lg"
                                                value={formState.date}
                                                //min={currentday}
                                            />
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className='mb-3'>
                                            <AvField
                                                name='time'
                                                label="Time"
                                                className='form-control'
                                                placeholder='Type Time'
                                                required
                                                errorMessage="This field is required"
                                                type='time'
                                                onChange={(e) => handleFieldChange(e)}
                                                bsSize="lg"
                                                value={formState.time}
                                            />
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <label>Activity Type </label>
                                        <Select
                                            placeholder='Select'
                                            options={[{
                                                label: "call", value: "call",

                                            }, {
                                                label: "meeting", value: "meeting",
                                            }, {
                                                label: "visit", value: "visit"
                                            }]}
                                            className='mb-3 '
                                            onChange={data => setFormState({ ...formState, activityType: data })}
                                            value={formState.activityType}
                                        // setOptions={options => setLeadOptions(options)}
                                        />
                                    </Col>
                                    {formState.activityType ?.value === "visit" ?
                                        <Col md={6}>
                                            <div className='mb-3'>
                                                <AvField
                                                    name='location'
                                                    label="Location"
                                                    className='form-control'
                                                    placeholder='Type Location'
                                                    required
                                                    onChange={(e) => handleFieldChange(e)}
                                                    bsSize="lg"
                                                    value={formState.location}
                                                />
                                            </div>
                                        </Col> : null
                                    }
                                    {/* <Col md={6}>
                                        <Label className='p-0 m-0 font-size-13'>
                                            Status
                                       </Label >
                                        <AvRadioGroup className="mt-2" required inline name="status" value={formState.status} onChange={handleFieldChange} >
                                            <AvRadio label="Upcoming" value="upcoming" />
                                            <AvRadio label="Canceled" value="canceled" />
                                            <AvRadio label="Done" value="done" />
                                        </AvRadioGroup>
                                    </Col> */}
                                    {/* <Col md={6}>
                                        <SelectOptions
                                            label='Compound '
                                            placeholder='Select'
                                            options={CompoundOptions}
                                            handleSelectChange={data => {
                                                setFormState({ ...formState, selectedCompound: data, selectedBulding: null, selectedProperty: null })
                                            }}
                                            selectedOption={formState.selectedCompound}
                                            Service={CompoundService}
                                            setOptions={options => setCompoundptions(options)}
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <label>Building</label>
                                        <Select
                                            placeholder='Select'
                                            options={buildingOptions}
                                            className='mb-3 '
                                            onChange={data => setFormState({ ...formState, selectedBulding: data, selectedProperty: null })}
                                            value={formState.selectedBulding}
                                            setOptions={options => setBuildingOptions(options)}
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <label>Property</label>
                                        <Select
                                            placeholder='Select'
                                            options={propertyOptions}
                                            className='mb-3 '
                                            onChange={data => setFormState({ ...formState, selectedProperty: data })}
                                            value={formState.selectedProperty}
                                            setOptions={options => setPropertyOptions(options)}
                                        />
                                    </Col> */}  
                                    {/* <Col md={6}>
                                        <SelectOptions
                                            id={"unitType"}
                                            label={"Select Unit Type"}
                                            options={unitTypeOptions}
                                            Service={UnitTypesService}
                                            selected={formState.unitType}
                                            setOptions={options => setUnitType(options)}
                                            handleSelectChange={(data) => {
                                                setFormState({ ...formState, unitType: data })

                                            }}
                                        />
                                    </Col> */}
                                    <Col md={6}>
                                        {/* <Label>Select Unit Type</Label> */}
                                        <SelectOptions
                                            placeholder='Select'
                                            label={"Select Unit Type"}
                                            options={unitTypeOptions}
                                            // className='mb-3 '
                                            handleSelectChange={(data) => {
                                                setFormState({ ...formState, unitType: data, selectedCompound: null,
                                                    selectedBulding: null, selectedProperty: null, selectedResale: null})
                                            }}
                                            Service={UnitTypesService}
                                            selectedOption={formState.unitType}
                                            setOptions={options => setUnitType(options)}
                                        />
                                    </Col>
                                    {!!formState.unitType && formState.unitType.label ==="Property in Compound" && <>
                                    <Col md={6}>
                                        <SelectOptions
                                                label='Compound '
                                                placeholder='Select'
                                                options={CompoundOptions}
                                                handleSelectChange={data => {
                                                    setFormState({ ...formState, selectedCompound: data, selectedBulding: null, selectedProperty: null})
                                                }}
                                                selectedOption={formState.selectedCompound}
                                                Service={CompoundService}
                                                setOptions={options => setCompoundptions(options)}
                                            />
                                    </Col>
                                    <Col md={6} >
                                        <label>Building</label>
                                        <Select
                                            placeholder='Select'
                                            options={buildingOptions}
                                            className='mb-3 '
                                            onChange={data => setFormState({ ...formState, selectedBulding: data, selectedProperty: null})}
                                            value={formState.selectedBulding}
                                            setOptions={options => setBuildingOptions(options)}
                                        />
                                    </Col>
                                    <Col>
                                        <label>Property</label>
                                        <Select
                                            placeholder='Select'
                                            options={propertyOptions}
                                            className='mb-3 '
                                            value={formState.selectedProperty}
                                            setOptions={options => setPropertyOptions(options)}
                                            onChange={(data) => {
                                                setFormState({ ...formState, selectedProperty: data })
                                            }} />
                                    </Col>
                                    </>}
                                    {!!formState.unitType && formState.unitType.label ==="Resale in Compound" && <>
                                    <Col md={6}>
                                        <label>Compound</label>
                                        <Select
                                                placeholder='Select'
                                                options={CompoundOptions}
                                                onChange={data => {
                                                    setFormState({ ...formState, selectedCompound: data, selectedResale:null})
                                                }}
                                                value={formState.selectedCompound}
                                                setOptions={options => setCompoundptions(options)}
                                            />
                                    </Col> 

                                    <Col md={6}>
                                        <label>Resale</label>
                                        <Select
                                            placeholder='Select'
                                            options={resaleOption}
                                            className='mb-3 '
                                            onChange={data => setFormState({ 
                                                ...formState, 
                                                selectedResale: data
                                            })}
                                            value={formState.selectedResale}
                                        />
                                    </Col>
                                    </>}
                                    {!!formState.unitType && formState.unitType.label ==="Resale Unit Outside Compound" && <>
                                    <Col md={6}>
                                        <label>Resale</label>
                                        <Select
                                            placeholder='Select'
                                            options={resaleOption}
                                            className='mb-3 '
                                            onChange={data => setFormState({ 
                                                ...formState, 
                                                selectedResale: data
                                            })}
                                            value={formState.selectedResale}
                                        />
                                    </Col>
                                    </>}
                                    {!!formState.unitType && formState.unitType.label ==="Other" && <>
                                    <Col md={6}>
                                        <AvField
                                                name='resale_name'
                                                label="Resale Name"
                                                placeholder='Resale Name'
                                                className='form-control'
                                                type="text"
                                                onChange={(e) => handleFieldChange(e)}
                                                bsSize="lg"
                                                value={formState.resale_name}
                                            />
                                    </Col>
                                    </>}
                                    <Col md={12}>
                                        <div className='mb-3'>
                                            <AvField
                                                name='description'
                                                label="Description"
                                                placeholder='Type Description'
                                                className='form-control'
                                                type="textarea"
                                                onChange={(e) => handleFieldChange(e)}
                                                bsSize="lg"
                                                value={formState.description}
                                            />
                                        </div>
                                    </Col>

                                </Row>
                            </CardBody>
                        </Card>
                        <Row className="d-flex justify-content-between pb-4">
                            <Col>
                                <button
                                    type="button"
                                    className="btn btnUpload btnHeight px-4"
                                    onClick={() => {
                                        setModal(true)
                                    }}
                                    size={"lg"}>
                                    Cancel
                  </button>
                            </Col>
                            <Col>
                                <button
                                    disabled={loading ? true : false}
                                    type='submit'
                                    className="btn btn-success btnHeight px-4 float-end"
                                    size={"lg"}
                                >
                                    Submit
                </button>
                            </Col>
                        </Row>
                        <CancelModal modal={modal}
                            setModal={setModal}
                            goBackHandler={() => {
                                props.history.goBack()
                            }}
                        />
                        <SuccessModal
                            modal={successModal}
                            message={id ? "Appointment Edited Successfully" : "New Appointment Added Successfully"}
                            onClick={() => props.history.goBack()}
                            title={id ? "Edit Appointment " : "Add New Appointment"}
                        />
                    </AvForm>
                </Container>
            </div>
        </React.Fragment>
    )
}
let validate = (str) => {
    let count = 0
    for (let i = 0; i < str.length; i++) {
        if ((str.charCodeAt(i) >= 65 && str.charCodeAt(i) <= 90) || (str.charCodeAt(i) >= 97 && str.charCodeAt(i) <= 122)) {
            count += 1
        }
    }

    return count >= 2 ? true : false

}
export default AddAppointment
